import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class HttpErrorService {
    public ignoreError(errorCode: number): boolean {
        return errorCode == 401 || errorCode == 200;
    }
}
